query allExtBasketballTeams(
  $first: Int,
  $offset: Int,
  $filter: BasketballTeamMappingFilter,
  ) {
  allBasketballTeamMappings(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      intId
      mappedEntity {
        name
        source
        teamId
      }
    }
    totalCount
  }
}
